import React from 'react'
import { IconClose } from '@Knowledge-OTP/znk-ui-components'
import useTranslation from '../../i18n/useTranslation'
import './index.css'

const ResetFiltersButton = ({ onClick, className = '', ...props }) => {
  const { translate } = useTranslation()

  const handleKeyDown = (event) => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault()
      onClick()
    }
  }

  return (
    <button
      type='button'
      className={`ml-2 reset-filters-button btn-link text-gray d-flex align-items-center ${className}`.trim()}
      onClick={onClick}
      onKeyDown={handleKeyDown}
      {...props}
    >
      <IconClose size={14} className='mr-1' color='primary' />
      {translate('misc.cleanFilters')}
    </button>
  )
}

export default ResetFiltersButton
